import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TIITSignInStore } from './types.ts';
import { IITInitialState } from './initialState.ts';
import {
  saveSigningControllerFromIIT,
  saveSignsFromIIT,
  startIITSigning,
  startIITSigningController,
} from './thunks.ts';
import {
  getFilesHashesToSign,
  saveFilesSignedDocuments,
} from '~/store/guarantees/thunks/filesSigningThunks.ts';
import {
  rejectedAction,
  saveIITFulfilledSignAction,
  startFilesSigningFulfilledAction,
  startSigningFulfilledAction,
  startSigningPendingAction,
} from './actions.ts';

const IITSlice = createSlice({
  name: 'iit',
  initialState: IITInitialState,
  reducers: {
    setIITError(state: TIITSignInStore, action: PayloadAction<string>) {
      state.error = action.payload;
      state.hasError = true;
      state.isSigning = false;
      state.isLoading = false;
      state.cloudKeyQRVerificationURL = 'https=//';
      state.isCloudKeyQRVerificationModalOpen = false;
      if (state.IITHashes.length) state.IITHashes = [];
      if (state.IITSigns.length) state.IITSigns = [];
      state.isIITSignsLoaded = false;
      state.isPrivateKeyLoaded = false;
    },
    dismissIITError(state: TIITSignInStore) {
      state.hasError = false;
      state.error = null;
    },
    dismissIITSigning() {
      return IITInitialState;
    },
    IITPrivateKeyLoaded(state: TIITSignInStore) {
      state.isPrivateKeyLoaded = true;
    },
    IITCloudVerification(state: TIITSignInStore, action: PayloadAction<string>) {
      state.isLoading = false;
      state.isCloudKeyQRVerificationModalOpen = true;
      state.cloudKeyQRVerificationURL = action.payload;
    },
    setIITLoading(state: TIITSignInStore, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(startIITSigning.pending, startSigningPendingAction)
      .addCase(startIITSigning.fulfilled, startSigningFulfilledAction)
      .addCase(startIITSigning.rejected, rejectedAction)
      .addCase(saveSignsFromIIT.fulfilled, saveIITFulfilledSignAction)
      .addCase(saveSignsFromIIT.rejected, rejectedAction)

      .addCase(startIITSigningController.pending, startSigningPendingAction)
      .addCase(startIITSigningController.fulfilled, startSigningFulfilledAction)
      .addCase(startIITSigningController.rejected, rejectedAction)
      .addCase(saveSigningControllerFromIIT.fulfilled, saveIITFulfilledSignAction)
      .addCase(saveSigningControllerFromIIT.rejected, rejectedAction)

      .addCase(getFilesHashesToSign.pending, startSigningPendingAction)
      .addCase(getFilesHashesToSign.fulfilled, startFilesSigningFulfilledAction)
      .addCase(getFilesHashesToSign.rejected, rejectedAction)
      .addCase(saveFilesSignedDocuments.fulfilled, saveIITFulfilledSignAction)
      .addCase(saveFilesSignedDocuments.rejected, rejectedAction);
  },
});

export const {
  setIITError,
  dismissIITError,
  dismissIITSigning,
  IITPrivateKeyLoaded,
  IITCloudVerification,
  setIITLoading,
} = IITSlice.actions;

export default IITSlice.reducer;
